<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="申请号">
          <el-input
            placeholder="请输入申请号"
            v-model="ruleForm.number"
          ></el-input>
        </el-form-item>
        <el-form-item label="关键字 ">
          <el-input
            v-model="ruleForm.crux"
            placeholder="支持专利名称及摘要模糊检索
"
          ></el-input>
        </el-form-item>
        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
      <span
        class="attention margin-top10 margin-bot10 margin-left20 margin-right20"
        @click="patenttrusteeship()"
        >同步专利</span
      >
    </div>

    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="loading"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width100
            text-ellipsis
            backwhite
            margin-top15
            border-rd3
            alldigital
          "
          v-if="pages != ''"
        >
          <div
            class="
              f14
              lineheight30
              pad-left20 pad-right20 pad-top20 pad-bot10
              bordert-tf
              dimencont
            "
            v-for="(item, index) in pages"
            :key="index"
          >
            <p class="f14 flex-betweennowrap cursorpointer dimensional">
              <span @click="toPatentdatails(index)"
                >{{ item.title }}({{ item.appNumber }})
                <span
                  class="f12"
                  :class="
                    item.dbName == '实用新型'
                      ? 'patensy'
                      : item.dbName == '外观专利'
                      ? 'patenwg'
                      : item.dbName == '发明专利'
                      ? 'patenzl'
                      : item.dbName == '发明授权'
                      ? 'patensq'
                      : ''
                  "
                  >{{ item.dbName }}</span
                ></span
              >
              <span>
                <el-button @click="Submitfromnull(index)">取消托管</el-button>
                <el-button @click="todialog(index)">增值服务</el-button>
              </span>
            </p>
            <p
              class="width70 flex-betweennowrap pad-top10"
              @click="toPatentdatails(index)"
            >
              <span>公开(公告)号 : {{ item.pubNumber }}</span>
              <span>申请（专利权）人 : {{ item.patentee }}</span>
              <span> 发明（设计）人 : {{ item.inventroName }}</span>
            </p>
            <p class="width70 flex-betweennowrap">
              <span>国省代码 : {{ item.proCode }}</span>
              <span>申请日 : {{ item.appDate }} </span>
              <span>公开(公告)日 : {{ item.pubDate }}</span>
            </p>
            <p>分类号 : {{ item.ipc }}</p>
            <p>主分类号 : {{ item.mainIpc }}</p>
          </div>
          <!-- 分页 -->
          <div
            v-if="pages != ''"
            class="
              flex-betweennowrap
              pad-top20 pad-bot20
              pagination
              pad-right10
              bordert-tf
            "
          >
            <span></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>

        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="pages == '' || pages == null"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
          >
            <p style="position: relative; bottom: 60px" class="f14">暂无数据</p>
          </el-empty>
        </div>
      </template>
    </el-skeleton>
    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      :show-close="true"
      width="30%"
      center
    >
      <div class="textalign-left f16">增值服务</div>
      <el-form class="demo-ruleForm margin-top20">
        <span class="bluecolor lineheight30">{{ companytitle }}</span>
        <el-form-item>
          <p>增值服务</p>
          <el-checkbox
            label="年费提醒"
            v-model="Remind"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
          <el-checkbox
            label="年费代缴"
            v-model="behalf"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
          <el-checkbox
            label="委托出售"
            v-model="sell"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
        </el-form-item>
        <el-form-item label="">
          <p>提醒日期</p>
          <el-date-picker
            v-model="warnDate"
            type="date"
            placeholder="请选择提醒日期"
            value-format="yyyy-MM-dd"
            :editable="false"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <div class="textalign-right margin-top20">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="Submitfrom()">提 交</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  patenttrusteeshipentpatent,
  patenttrusteeshipupdate,
  patenttrusteeshipremove,
  patenttrusteeshipsyncpatent,
} from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";
import BUS from "@/BUS/BUS";
import switchcore from "@/components/switchcore.vue";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      companytitle: "",
      pagination: false,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      warnDate: "",
      allpage: [],
      ruleForm: {
        number: "",
        crux: "",
      },
      serchkey: true,
    };
  },
  components: {
    callback,
    switchcore,
  },
  inject: ["reload"],
  methods: {
    // 清空input
    resetForm() {
      this.thisNum = 1;
      this.ruleForm.number = "";
      this.ruleForm.crux = "";
      patenttrusteeshipentpatent({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitForm() {
      patenttrusteeshipentpatent({
        appNumber: this.ruleForm.number,
        _keywords: this.ruleForm.crux,
        page: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 增值服务
    todialog(index) {
      this.centerDialogVisible = true;
      this.allpage = this.pages[index];
    },
    Submitfrom() {
      patenttrusteeshipupdate({
        id: this.allpage.id,
        DataType: 1,
        warn: this.Remind,
        warnDate: this.warnDate,
        patentfee: this.behalf,
        sell: this.sell,
      }).then((res) => {
        if (res.data.code == 200) {
          this.centerDialogVisible = false;
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
          this.refresh();
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 取消托管
    Submitfromnull(index) {
      this.$confirm("此操作将取消托管, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          patenttrusteeshipremove({ id: this.pages[index].id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "取消成功",
                type: "success",
              });
              this.refresh();
            } else {
              this.drawer = false;
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 同步专利
    patenttrusteeship() {
      patenttrusteeshipsyncpatent().then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已同步",
            type: "success",
          });
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    toPatentdatails(index) {
      window.sessionStorage.setItem("patentmanage", this.pages[index].id);
      this.$router.push({ path: "/intellectual-property/manage-details" });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      patenttrusteeshipentpatent({
        page: val,
        appNumber: this.ruleForm.number,
        _keywords: this.ruleForm.crux,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;

          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      patenttrusteeshipentpatent({
        page: 1,
        limit: val,
        appNumber: this.ruleForm.number,
        _keywords: this.ruleForm.crux,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    refresh() {
      this.$loading.show(); // 显示loading
      patenttrusteeshipentpatent({
        page: this.thisNum,
        appNumber: this.ruleForm.number,
        _keywords: this.ruleForm.crux,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },

  created() {
    this.companytitle = window.sessionStorage.getItem("companytitle");

    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.$loading.show(); // 显示loading
    patenttrusteeshipentpatent({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.pages.forEach((i) => {
          if (i.dbName == "SYXX") {
            i.dbName = "实用新型";
          }
          if (i.dbName == "FMZL") {
            i.dbName = "发明专利";
          }
          if (i.dbName == "WGZL") {
            i.dbName = "外观专利";
          }
          if (i.dbName == "FMSQ") {
            i.dbName = "发明授权";
          }
        });
      } else {
        this.drawer = false;
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.dimencont:hover {
  background: #f5fcfc;
}
.patenbtn {
  background: #678feb;
  color: #f9f9f9;
  padding: 2px 10px 2px 10px;
  border-radius: 3px;
}
.patensy {
  color: #7b83ea;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e8eaf9;
  border-radius: 11px;
}
.patenwg {
  color: #52c5cb;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e4f1f5;
  border-radius: 11px;
}
.patenzl {
  color: #f96d68;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #f5e8eb;
  border-radius: 11px;
}
.patensq {
  color: #5599ff;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e5ecfb;
  border-radius: 11px;
}
.patenbtn:hover {
  background: #88a7f0;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>